/* eslint-disable */


export default {
	init() {
		// JavaScript to be fired on the home page
	},
	finalize() {


		class AnimateHeader {

			constructor() {
				this.header = document.querySelector('.page-header-home');
				this.sliderNav = document.querySelector('.slider-nav');
				this.sliderNavItems = this.sliderNav.querySelectorAll('.inner > .blue');
				this.images = document.querySelectorAll('.wrap-images > img');
				this.poster = document.querySelector('.poster');
				this.handleEvents()
			}

			handleEvents() {
				// this.sliderNav.addEventListener('mouseover', e => this.hoverLogic(e));
				// this.sliderNav.addEventListener('mouseout', e => this.addAnimation(e));

				this.sliderNav.querySelectorAll('.inner').forEach((element, index) => {
					element.addEventListener('mouseover', e => this.hoverLogic(e));
					element.addEventListener('mouseout', e => this.addAnimation(e));

				});
				this.sliderNav.addEventListener('mouseleave', e => {
					setTimeout(() => {
						this.poster.classList.remove('active')
					}, 2500)
				});
			}

			hoverLogic(e) {
				// const currentPoster
				// this.poster.classList.remove('active')
				const target = e.target
				const parent = target.closest('.inner');
				const matchingImage = this.header.querySelector(`img[data-index="${parent.dataset.index}"]`);
				console.log(matchingImage)
				if (parent && matchingImage) {
					this.removeAnimation()
					matchingImage.classList.add('hovered')
					this.poster.querySelector('img').src = `${matchingImage.getAttribute('src')}`
					this.poster.classList.add('active')
					this.sliderNavItems.forEach(item => {
						item.classList.add('hovered')
					})
				}
			}

			removeAnimation() {
				this.sliderNavItems.forEach(item => item.style.animation = 'none')
				this.images.forEach(item => item.style.animation = 'none')
			}

			addAnimation(e) {

				const targetIndex = parseInt(e.target.closest('.inner').dataset.index)
				const activeImage = this.header.querySelector(`img.hovered`);
				activeImage && activeImage.classList.remove('hovered')

				this.sliderNavItems.forEach((item, i) => {
					item.style.animation = 'progress-bar 12s infinite'
					this.modifyAnimationValues(targetIndex, item, i)
				})

				this.images.forEach((item, i) => {
					item.style.animation = 'fadeInOut1 12s infinite'
					this.modifyAnimationValues(targetIndex, item, i)
				})
			}

			modifyAnimationValues(targetIndex, item, i) {

				if (targetIndex === 0) {
					if (i === targetIndex) {
						item.style.animationDelay = '0s';
						item.style.zIndex = '3'
					}
					if (i === (targetIndex + 1)) {
						item.style.animationDelay = '4s';
						item.style.zIndex = '2'
					}
					if (i === (targetIndex + 2)) {
						item.style.animationDelay = '8s'
						item.style.zIndex = '1'
					}

				} else if (targetIndex === 1) {
					if (i === (targetIndex - 1)) {
						item.style.animationDelay = '8s'
						item.style.zIndex = '1'
					}
					if (i === targetIndex) {
						item.style.animationDelay = '0s'
						item.style.zIndex = '3'
					}
					if (i === (targetIndex + 1)) {
						item.style.animationDelay = '4s'
						item.style.zIndex = '2'
					}
				} else if (targetIndex === 2) {

					if (i === (targetIndex - 2)) {
						item.style.animationDelay = '4s'
						item.style.zIndex = '2'
					}

					if (i === (targetIndex - 1)) {
						item.style.animationDelay = '8s'
						item.style.zIndex = '1'
					}

					if (i === targetIndex) {
						item.style.animationDelay = '0s'
						item.style.zIndex = '3'
					}
				}
			}


		}

		// new AnimateHeader();


		// class Animate {
		// 	constructor() {
		// 		this.wrapper = document.querySelector('#wrapper');
		// 		this.handleEvents()
		// 	}
		//
		// 	handleEvents() {
		// 		document.addEventListener('mouseover', (e) => {
		// 			e.target.classList.contains('link') && this.showImage(e.target)
		// 		})
		// 		document.addEventListener('mouseout', (e) => {
		// 			e.target.classList.contains('link') && this.hideImage(e.target)
		// 		})
		// 	}
		//
		// 	showImage(target) {
		// 		const currentImage = document.querySelector(`img[data-i="${target.dataset.i}"]`)
		// 		currentImage.classList.add('show')
		// 	}
		// }
		//
		// new Animate()
	},


}





// WEBPACK FOOTER //
// ./scripts/routes/home.js